/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { InnerWhere } from './InnerWhere/InnerWhere';

/**
 * WhereCondition displays Where filter section.
 * @returns WhereCondition Element.
 */
export const WhereCondition = ({
  handleChange,
}: {
  handleChange: Function;
}) => {
  return (
    <div className="filterWhere">
      <CustomAccordion title={filterSections.whereRelativeOrbit.title}>
        <InnerWhere handleChange={handleChange} />
      </CustomAccordion>
    </div>
  );
};
